import type { DisbursementsType } from "@/redux/disbursements/disbursementsType";

export const initialState: DisbursementsType = {
  fetching: false,
  message: null,
  approvalMessage: null,
  error: null,
  success: null,
  approvalSuccess: null,
  statusCode: null,
  disbursementsList: [],
  singleDisbursement: [],
  totalCount: 0,
  sharedDisbursementList: [],
  totalSharedCount: 0,
  totalAmount: 0,
  remainingAmount: 0,
};
